export const WidgetFooter = () => {
  return (
    <div className='w-full rounded-b-lg border-t bg-gray-50 px-6 py-4'>
      <h6 className='text-center'>
        powered by <span className='font-semibold'>Enable Rewards</span>
      </h6>
    </div>
  );
};
